export default __webpack_public_path__ + "static/media/LogoAMD.ff4cb651.png";